import RecommendedCharts from './RecommendedCharts';
import './RecommendedCharts.scss';

export default RecommendedCharts;